import { ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { TransactionHistoryItemViewModel } from './transaction-history.page';

@Component({
    selector: 'app-transaction-history-item-article[transactionItem]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    :host {
      display: block;
    }
  `],
    template: `
    <div class="d-flex flex-row border-bottom ps-3 pt-3 pb-3 align-items-center">
      <div class="flex-column col-7">
        <div class="d-flex flex-row align-items-center">
          <div class="position-relative">
            <div class="d-block square-image bg-light shadow-sm border"
                 [style.background-image]="transactionItem?.productImage && 'url(' + transactionItem?.productImage + ')'">
            </div>
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info">
            {{transactionItem?.quantity}}
          </span>
            <span *ngIf="transactionItem?.returned_quantity" class="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger">
            {{transactionItem?.returned_quantity}}
          </span>
          </div>

          <div class="flex-grow-1 ps-2" [style.color]="transactionItem?.quantity === transactionItem?.returned_quantity && 'rgb(165 175 165)'">{{transactionItem?.title}}</div>
        </div>


      </div>
      <div class="flex-column ps-3 col-2">{{transactionItem?.code}}</div>
      <div class="flex-column d-flex align-items-end ps-3 col-3">
        <!-- FIXME: money formatter required -->
        <span class="flex-row fs-6 text-info fw-bold text-end">{{transactionItem?.amount | currency}}</span>
        <span class="flex-row text-muted text-end">{{transactionItem?.taxAmount | currency}} ({{transactionItem?.taxRate}}%)</span>
      </div>
    </div>
  `,
    standalone: false
})
export class HistoryItemArticleComponent {
  @Input() transactionItem!: TransactionHistoryItemViewModel | null;
}
